<div class="d-flex h-100 w-100 px-0 px-lg-2 px-xl-5 py-3 shadow rounded-3"
  style="backdrop-filter: blur(10px);background: rgba(255, 255, 255, 0.8);">

  <div class="w-100 h-100 d-flex flex-column">
    <div class="d-flex align-items-center justify-content-end gap-3 w-100">
      <button class="customPreActivatedButtons" [disabled]="selection.selected.length < 2" (click)="onBulkDelete()">Bulk
        Delete</button>

      <button class="customPreActivatedButtons" type="button" (click)="addUser()"><mat-icon>person_add</mat-icon> Add
        User</button>
    </div>

    <div class="overflow-auto h-100 w-100 mt-4">
      <table mat-table [dataSource]="dataSource" class="table m-0">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (click)="$event.stopPropagation()" (change)="toggleSelectAll($event)"
              [checked]="isAllSelected()" [indeterminate]="isAllSelected() && !isAllSelected()"></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let element">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="onCheckboxChange(element)"
              [checked]="selection.isSelected(element)"></mat-checkbox>
          </td>
        </ng-container>

        <!-- User ID Column -->
        <ng-container matColumnDef="userID">
          <th mat-header-cell *matHeaderCellDef> User ID </th>
          <td mat-cell *matCellDef="let element"> {{ element.userId }} </td>
        </ng-container>

        <!-- Email Column -->
        <ng-container matColumnDef="emailID">
          <th mat-header-cell *matHeaderCellDef> Email </th>
          <td mat-cell *matCellDef="let element"> {{ element.emailId }} </td>
        </ng-container>

        <!-- First Name Column -->
        <ng-container matColumnDef="firstname">
          <th mat-header-cell *matHeaderCellDef> First Name </th>
          <td mat-cell *matCellDef="let element"> {{ element.firstName }} </td>
        </ng-container>

        <!-- Last Name Column -->
        <ng-container matColumnDef="lastName">
          <th mat-header-cell *matHeaderCellDef> Last Name </th>
          <td mat-cell *matCellDef="let element"> {{ element.lastName }} </td>
        </ng-container>

        <!-- Role Column -->
        <ng-container matColumnDef="role">
          <th mat-header-cell *matHeaderCellDef> Role </th>
          <td mat-cell *matCellDef="let element">
            {{ element.role?.trim() ? element.role.trim().replace('ROLE_', '').toUpperCase() : '' }}
          </td>
        </ng-container>

        <!-- Primary Skill Column -->
        <ng-container matColumnDef="primarySkill">
          <th mat-header-cell *matHeaderCellDef> Primary Skill </th>
          <td mat-cell *matCellDef="let element"> {{ element.primarySkill }} </td>
        </ng-container>

        <!-- Last Login Column -->
        <ng-container matColumnDef="lastlogin">
          <th mat-header-cell *matHeaderCellDef> Last Login </th>
          <td mat-cell *matCellDef="let element"> {{ element.lastlogin }} </td>
        </ng-container>


        <ng-container matColumnDef="delete">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let element">
            <!-- <button class="btn btn-primary" type="button" [disabled]="!selection.isSelected(element)" (click)="onDelete(element)">
          Delete
        </button> -->

            <button matTooltip="Delete User" mat-icon-button
              (click)="onDelete(element)"><mat-icon>delete</mat-icon></button>

          </td>
        </ng-container>

        <!-- Header and Row Definitions -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <!-- (click)="onRowClick(row.userId)"  style="cursor: pointer;"   -->
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>


    <mat-paginator [pageSizeOptions]="[5, 10, 20]" [pageSize]="10" showFirstLastButtons></mat-paginator>
  </div>
</div>